import { useEffect, useState } from 'react';

import { isUndefined } from 'lodash';
import { useAccountSelector } from 'src/hooks';
import { MFormSection, MTypography } from 'src/lib';
import { Color, Spacing } from 'src/styles';
import { getAccountHolderSubheader } from 'src/utils';

import { FinancialInformationEmploymentForm } from './FinancialInformationEmploymentForm';
import { FinancialInformationEmploymentView } from './FinancialInformationEmploymentView';

export const AccountHolderFinancialEmploymentSection = () => {
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  const { account } = useAccountSelector();

  const onEdit = () => {
    setIsEditMode(true);
  };

  const onCancel = () => {
    setIsEditMode(false);
  };

  const isFinancialInformationEmoloymentAlreadySaved = () =>
    !isUndefined(account?.primaryAccountHolder?.financialInformation?.employmentStatus);

  useEffect(() => {
    if (isFinancialInformationEmoloymentAlreadySaved()) {
      setIsEditable(true);
    }
  }, [account?.primaryAccountHolder?.financialInformation]);

  return (
    <>
      <MTypography variant='h4' weight='normal' color={Color.Brand6} className={Spacing.my32}>
        {getAccountHolderSubheader({
          isPrimary: true,
          type: account?.type,
        })}
      </MTypography>
      <MFormSection
        title='Employment Information'
        onEdit={onEdit}
        disabled={Boolean(account?.lastFailedLinkAttemptError)}
        isEditable={isEditable}
        isEditMode={isEditMode}
        testId={'primary-employment-information'}>
        {isFinancialInformationEmoloymentAlreadySaved() && !isEditMode ? (
          <FinancialInformationEmploymentView accountHolder={account?.primaryAccountHolder} testId={'primary'} />
        ) : (
          <FinancialInformationEmploymentForm
            accountHolder={account?.primaryAccountHolder}
            accountUuid={account?.id}
            onCancel={onCancel}
            testId={'primary'}
          />
        )}
      </MFormSection>
    </>
  );
};
